import { Button, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { paths } from '@/routes/paths';

export function NotFoundPage() {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      spacing={2}
      sx={{ py: 12, textAlign: 'center' }}
    >
      <Typography variant="h2" fontWeight={800} color="primary">
        404
      </Typography>
      <Typography variant="h5">Page not found</Typography>
      <Typography variant="body2" color="text.secondary" maxWidth={440}>
        The page you&apos;re looking for doesn&apos;t exist or may have moved.
      </Typography>
      <Button component={RouterLink} to={paths.dashboard} variant="contained">
        Back to dashboard
      </Button>
    </Stack>
  );
}
